<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import InputGroup from "@/components/forms/input-group";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        InputGroup,
    },
    data() {
        return {
            id: null,
            title: `Booking View`,
            modeName: 'View',
            items: [
                {
                    text: "Booking"
                },
                {
                    text: 'View',
                    active: true,
                },
            ],
            data: {
                shopify_id: null,
                order_id: null,
                customer_firstname: null,
                customer_lastname: null,
                orderItems: [
                    {
                        branch_id: null,
                        product_name: null,
                        product_id: null,
                        sku: null,
                        staff_id: null,
                        booking_date: null,
                        booking_time: null,
                        customer_email: null,
                        shared_at: null,
                        order_id: null,
                        booking_ref: null,
                        redeem_at: null,
                        status: null,
                        timeslotCategoryId: null,
                        request_from: null,
                        has_preferred_staff: 1,
                        remarks: null
                    }
                ],
            },
            stacksOptions: [],
            stacksChecked: [],
            errors: {},
        };
    },
    async created() {
        this.id = this.$route.params.id;
    },
    computed: {
    },
    watch: {
        //
    },
    async mounted() {
        try {
            const result = await axios.get(`${process.env.VUE_APP_APIURL}/staff-order-details/${this.id}`, {
                headers: authHeader(),
            });
            if (result && result.data['code'] === 'success') {
                const order_detail = result.data['data']['order'];

                this.data.shopify_id = order_detail.shopify_id ?? null;
                this.data.customer_firstname = order_detail.customer_firstname ?? null;
                this.data.customer_lastname = order_detail.customer_lastname ?? null;

                const items = result.data['data']['order']['items'];
                if (items && items.length > 0) {
                    const item = items[0];
                    this.data.orderItems[0].branch_id = item.branch_id;
                    this.data.orderItems[0].branch_name = item.branch_name;
                    this.data.orderItems[0].product_id = item.shopify_product_id;
                    this.data.orderItems[0].product_name = item.product_name;
                    this.data.orderItems[0].sku = item.sku;
                    this.data.orderItems[0].staff_id = item.staff_id;
                    this.data.orderItems[0].staff_name = item.staff_name;
                    this.data.orderItems[0].remarks = item.remarks;
                    if (item.booking_at) {
                        this.data.orderItems[0].booking_date = item.booking_at.split(' ')[0];
                        this.data.orderItems[0].booking_time = item.booking_at.split(' ')[1];
                    }

                    this.data.orderItems[0].status = item.status;
                    this.data.orderItems[0].customer_email = item.customer_email;
                    this.data.orderItems[0].shared_at = item.shared_at;
                    this.data.orderItems[0].booking_ref = item.booking_ref;
                    this.data.orderItems[0].order_id = item.order_id;
                    this.data.orderItems[0].redeem_at = item.redeem_at;
                    this.stacksOptions = result.data['data']['order']['stack_items'] || [];
                    this.stacksChecked = item.stacks != null ? item.stacks : [];
                }
            } else {
                console.error('API returned error:', result?.data);
            }
        } catch (error) {
            console.error('Error fetching staff order details:', error);
        }
    },
    methods: {
        back() {
            this.$router.back();
        },
        capitalizeFirstLetter(value) {
            if (typeof value !== 'string') {
                return value;
            }
            
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="card p-3">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup :readOnly="true" id="branch_name" displayName="Branch" v-model="data.orderItems[0].branch_name" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="text" :readOnly="true" id="treatment" displayName="Treatment" v-model="data.orderItems[0].product_name" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup :readOnly="true" type="text" id="sku" displayName="SKU" v-model="data.orderItems[0].sku" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup id="therapist" :readOnly="true" displayName="Therapist" v-model="data.orderItems[0].staff_name" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup id="booking_date" :readOnly="true" displayName="Booking Date" v-model="data.orderItems[0].booking_date" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup id="booking_time" :readOnly="true" displayName="Booking Time" v-model="data.orderItems[0].booking_time" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="text" :readOnly="true" id="customer_firstname" displayName="Customer First Name" v-model="data.customer_firstname" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="text" :readOnly="true" id="customer_lastname" displayName="Customer Last Name" v-model="data.customer_lastname" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="email" id="customer_email" :readOnly="true" displayName="Customer Email" v-model="data.orderItems[0].customer_email" />                
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup :readOnly="true" type="text" id="status" displayName="Status" :value="capitalizeFirstLetter(data.orderItems[0].status)"/>
                </div>

                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup :readOnly="true" type="textarea" id="remarks" displayName="Remarks" v-model="data.orderItems[0].remarks" :error="errors[`orderItems.0.remarks`]" />
                </div>

                <div class="col-12" v-if="this.stacksOptions.length > 0">
                    <h6 class="m-0 font-weight-bold">Booking Stacks with:</h6>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox m-0 mb-2" v-for="item in stacksOptions" :key="item.id">
                            <input type="checkbox" class="custom-control-input" :value="item.id" :id="item.id" v-model="stacksChecked" disabled>
                            <label class="custom-control-label" :for="item.id">{{ item.product_name }} - {{ item.booking_ref }}</label>
                        </div>
                    </div>
                </div>
            </div>
            
            <div>
                <h6 class="m-0 font-weight-bold">Shopify Order ID:</h6>
                <p class="mb-3">{{ data.shopify_id ?? '-'}}</p>

                <h6 class="m-0 font-weight-bold">Booking ID:</h6>
                <p class="mb-3">{{ data.orderItems[0].order_id }}</p>

                <h6 class="m-0 font-weight-bold">Booking Code:</h6>
                <p class="mb-3">{{ data.orderItems[0].booking_ref }}</p>

                <h6 class="m-0 font-weight-bold">Shared:</h6>
                <p class="mb-3">{{ data.orderItems[0].shared_at ? 'Yes' : 'No' }}</p>

                <!-- <h6 class="m-0 font-weight-bold">Redeem Date:</h6>
                <p class="mb-3">{{ data.orderItems[0].redeem_at ?? '-' }}</p> -->
            </div>

            <div class="row">
                <div class="col-sm-2">
                    <router-link class="btn btn-success mb-2" :to="{path: '/booking'}">Back</router-link>
                </div>
            </div>
        </div>
    </Layout>
</template>